import { Phone, MessageSquare, FolderOpen } from "lucide-react";
import { PHONES } from "@/lib/site";

export default function MobileBar() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-ink/95 backdrop-blur-md text-cream grid grid-cols-3 border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-sticky-bar"
    >
      <a
        href={`tel:${PHONES[0].tel}`}
        data-testid="mobile-bar-call"
        className="flex flex-col items-center justify-center gap-1 py-3 hover:text-sage transition-colors"
      >
        <Phone size={18} />
        <span className="text-[11px] font-semibold tracking-wide">Call</span>
      </a>
      <a
        href="#contact"
        data-testid="mobile-bar-enquire"
        className="flex flex-col items-center justify-center gap-1 py-3 bg-moss hover:bg-moss-dark transition-colors"
      >
        <MessageSquare size={18} />
        <span className="text-[11px] font-semibold tracking-wide">Enquire</span>
      </a>
      <a
        href="#projects"
        data-testid="mobile-bar-projects"
        className="flex flex-col items-center justify-center gap-1 py-3 hover:text-sage transition-colors"
      >
        <FolderOpen size={18} />
        <span className="text-[11px] font-semibold tracking-wide">Projects</span>
      </a>
    </div>
  );
}
